var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isMobileScreen)?_c('ylNewsDetailsMobile',_vm._b({},'ylNewsDetailsMobile',_vm.$attrs,false)):_c('ylNewsDetailsPC',_vm._b({},'ylNewsDetailsPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }